import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  // On mount, ask the backend who we are. The browser will attach the httpOnly
  // auth cookie automatically. /auth/session always returns HTTP 200 with
  // {user: null} for anonymous visitors so the page load stays free of red
  // 401 console noise.
  useEffect(() => {
    api
      .get("/auth/session")
      .then((r) => setUser(r.data?.user || null))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password, website: "" });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/session");
      setUser(r.data?.user || null);
    } catch (_) {}
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
